import { appApi } from 'slices/api'

export interface duplicateThreshold {
  warningThreshold: number
  acceptanceThreshold: number
}
/// This is the collection of api endpoints used for the child duplicate process.
/// check the 'extra reducers' for a matcher that will fire after the api successfully completes an action, and use that to update the state.
/// This isnt exactly ideal as far as caching goes for the queries, since you're basically storing the call results in both the api and the slice state, but we want to
/// be able to manipulate this data with our logic in the state slice. If we are doing something that isnt manipulating anything, we can use the tags collection as expected
const duplicateChildApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getDuplicateThresholds: builder.query<duplicateThreshold, void | never>({
      query: () => ({
        url: 'globalSetting/GetDuplicateApprovalTresholds',
        method: 'get',
        credentials: 'include'
      }),
      providesTags: (result: duplicateThreshold | undefined, error, arg) => [{ type: 'DuplicateThreshold', value: result }]
    })
  }),
  overrideExisting: false
})

export const { useGetDuplicateThresholdsQuery } = duplicateChildApi
